import { compositeOtherJudgeIds } from "score-common";

// #3419 -- a class's judgeAssignments carry a composite judge's booth as the
// FVD run-together name ("Smith Jones"), one string. The score-api public pages
// expand it server-side (lib/composite-judge.js expandJudgeAssignmentsForDisplay);
// announcer-fe reads the class list directly, so it expands the same way from the
// show's judge roster plus its composite-judge mappings: a position's stored
// string is matched to a roster row by "firstName lastName" (the construction
// daysheet.js uses to resolve a panel entry, a comparison, never a name parse),
// and a row with a mapping reads as its primary judge then its other judges in
// the order they were added (a composite is 2 to 5 real judges).
const fullName = (row) => [row?.firstName, row?.lastName].filter(Boolean).join(" ").trim();

// Map<composite roster name, string[] real judge names, primary first>.
// Empty when nothing is mapped, so an ordinary class is untouched.
export function compositeNamesByRosterName(judges, maps) {
  const out = new Map();
  const rowById = new Map((judges || []).filter(Boolean).map((j) => [j.id, j]));
  for (const mapping of maps || []) {
    const composite = rowById.get(mapping?.id);
    const compositeName = fullName(composite);
    if (!compositeName) continue;
    const names = [mapping.primaryJudgeId, ...compositeOtherJudgeIds(mapping)]
      .map((id) => fullName(rowById.get(id)))
      .filter(Boolean);
    // No resolvable real judge (data drift): keep the stored name as it is.
    if (names.length) out.set(compositeName, names);
  }
  return out;
}
